import React from 'react';

export interface IconProps {
  size?: number;
  className?: string;
  children?: React.ReactNode;
}

const Icon: React.FC<IconProps> = ({
  className = 'block text-white',
  children,
  size = 25,
}) => {
  return (
    <span className={className} style={{ height: size, width: size }}>
      {children}
    </span>
  );
};

export default Icon;
